// removed by extract-text-webpack-plugin
module.exports = {"verticallyCentered":"BunsenModal-style__verticallyCentered__1tEL8","horizontallyRight":"BunsenModal-style__horizontallyRight__1trnD","horizontallyCentered":"BunsenModal-style__horizontallyCentered__18I6E","verticallyHorizontallyCentered":"BunsenModal-style__verticallyHorizontallyCentered__qFuNb"};


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/components/BunsenModal/BunsenModal-style.scss
// module id = 703
// module chunks = 4 6 7 8 9 13 17